// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as PublicRouteRouteImport } from './routes/_public/route'
import { Route as ActivateRouteImport } from './routes/activate'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as LinksRouteImport } from './routes/links'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as PublicIndexRouteImport } from './routes/_public/index'
import { Route as PublicAboutRouteImport } from './routes/_public/about'
import { Route as PublicBookRouteImport } from './routes/_public/book'
import { Route as PublicContactRouteImport } from './routes/_public/contact'
import { Route as PublicDisclaimerRouteImport } from './routes/_public/disclaimer'
import { Route as PublicEditorialPolicyRouteImport } from './routes/_public/editorial-policy'
import { Route as PublicHelpRouteImport } from './routes/_public/help'
import { Route as PublicPrivacyRouteImport } from './routes/_public/privacy'
import { Route as PublicRefundRouteImport } from './routes/_public/refund'
import { Route as PublicServicesRouteImport } from './routes/_public/services'
import { Route as PublicTermsRouteImport } from './routes/_public/terms'
import { Route as BousalaPlayRouteImport } from './routes/bousala.play'
import { Route as DotlovableOauthConsentRouteImport } from './routes/[.]lovable.oauth.consent'
import { Route as AuthenticatedAdminIndexRouteImport } from './routes/_authenticated/admin/index'
import { Route as AuthenticatedAdminBlogRouteImport } from './routes/_authenticated/admin/blog'
import { Route as AuthenticatedAdminBookingsRouteImport } from './routes/_authenticated/admin/bookings'
import { Route as AuthenticatedAdminBousalaRouteImport } from './routes/_authenticated/admin/bousala'
import { Route as AuthenticatedAdminCasesRouteImport } from './routes/_authenticated/admin/cases'
import { Route as AuthenticatedAdminFormsRouteImport } from './routes/_authenticated/admin/forms'
import { Route as AuthenticatedAdminMethodologyKbRouteImport } from './routes/_authenticated/admin/methodology-kb'
import { Route as AuthenticatedAdminPaymentsRouteImport } from './routes/_authenticated/admin/payments'
import { Route as AuthenticatedAdminPendingPurchasesRouteImport } from './routes/_authenticated/admin/pending-purchases'
import { Route as AuthenticatedAdminServicesRouteImport } from './routes/_authenticated/admin/services'
import { Route as AuthenticatedAdminTestimonialsRouteImport } from './routes/_authenticated/admin/testimonials'
import { Route as AuthenticatedAdminTraumaRouteImport } from './routes/_authenticated/admin/trauma'
import { Route as AuthenticatedBousalaRepairRouteImport } from './routes/_authenticated/bousala.repair'
import { Route as AuthenticatedFormsSlugRouteImport } from './routes/_authenticated/forms.$slug'
import { Route as AuthenticatedPortalIndexRouteImport } from './routes/_authenticated/portal.index'
import { Route as AuthenticatedPortalCoursesRouteImport } from './routes/_authenticated/portal.courses'
import { Route as AuthenticatedPortalSmartRouteImport } from './routes/_authenticated/portal.smart'
import { Route as AuthenticatedPortalTarbawiyaRouteImport } from './routes/_authenticated/portal.tarbawiya'
import { Route as PublicBlogIndexRouteImport } from './routes/_public/blog.index'
import { Route as PublicBlogSlugRouteImport } from './routes/_public/blog.$slug'
import { Route as PublicBookIndexRouteImport } from './routes/_public/book.index'
import { Route as PublicBousalaIndexRouteImport } from './routes/_public/bousala.index'
import { Route as PublicBousalaPendingRouteImport } from './routes/_public/bousala.pending'
import { Route as PublicBousalaSmartRouteImport } from './routes/_public/bousala.smart'
import { Route as PublicBousalaSuccessRouteImport } from './routes/_public/bousala.success'
import { Route as PublicCoursesIndexRouteImport } from './routes/_public/courses.index'
import { Route as PublicCoursesSplatRouteImport } from './routes/_public/courses.$'
import { Route as PublicRTokenRouteImport } from './routes/_public/r.$token'
import { Route as PublicServicesSlugRouteImport } from './routes/_public/services.$slug'
import { Route as AuthenticatedAdminBousalaIndexRouteImport } from './routes/_authenticated/admin/bousala.index'
import { Route as AuthenticatedAdminBousalaAnalyticsRouteImport } from './routes/_authenticated/admin/bousala.analytics'
import { Route as AuthenticatedAdminBousalaAttemptsRouteImport } from './routes/_authenticated/admin/bousala.attempts'
import { Route as AuthenticatedAdminBousalaNarrativeCacheRouteImport } from './routes/_authenticated/admin/bousala.narrative-cache'
import { Route as AuthenticatedAdminBousalaPurchasesRouteImport } from './routes/_authenticated/admin/bousala.purchases'
import { Route as AuthenticatedAdminBousalaReviewRouteImport } from './routes/_authenticated/admin/bousala.review'
import { Route as AuthenticatedAdminBousalaSettingsRouteImport } from './routes/_authenticated/admin/bousala.settings'
import { Route as AuthenticatedAdminBousalaSmartRouteImport } from './routes/_authenticated/admin/bousala.smart'
import { Route as AuthenticatedAdminCasesIdRouteImport } from './routes/_authenticated/admin/cases.$id'
import { Route as AuthenticatedAdminFormsIdRouteImport } from './routes/_authenticated/admin/forms.$id'
import { Route as AuthenticatedPortalBousalaAttemptIdRouteImport } from './routes/_authenticated/portal.bousala.$attemptId'
import { Route as PublicBookConfirmIdRouteImport } from './routes/_public/book.confirm.$id'
import { Route as PublicCoursesTraumaIdRouteImport } from './routes/_public/courses.trauma.$id'
import { Route as PublicShareReportsTokenRouteImport } from './routes/_public/share.reports.$token'
import { Route as AuthenticatedAdminBousalaAttemptsIndexRouteImport } from './routes/_authenticated/admin/bousala.attempts.index'
import { Route as AuthenticatedAdminBousalaAttemptsAttemptIdRouteImport } from './routes/_authenticated/admin/bousala.attempts.$attemptId'
import { Route as AuthenticatedAdminBousalaSmartIndexRouteImport } from './routes/_authenticated/admin/bousala.smart.index'
import { Route as AuthenticatedAdminBousalaSmartIdRouteImport } from './routes/_authenticated/admin/bousala.smart.$id'
import { Route as AuthenticatedCoursesTraumaIdLessonsRouteImport } from './routes/_authenticated/courses.trauma.$id.lessons'
import { Route as AuthenticatedCoursesTraumaIdPlayRouteImport } from './routes/_authenticated/courses.trauma.$id.play'
import { Route as PublicCoursesTraumaBuyProductSlugRouteImport } from './routes/_public/courses.trauma.buy.$productSlug'
import { Route as AuthenticatedCoursesTraumaIdResultAttemptIdRouteImport } from './routes/_authenticated/courses.trauma.$id.result.$attemptId'

const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const PublicRouteRoute = PublicRouteRouteImport.update({
            id: '/_public',getParentRoute: () => rootRouteImport
          })
const ActivateRoute = ActivateRouteImport.update({
            id: '/activate',path: '/activate',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const LinksRoute = LinksRouteImport.update({
            id: '/links',path: '/links',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRouteRoute
          })
const PublicIndexRoute = PublicIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PublicRouteRoute
          })
const PublicAboutRoute = PublicAboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => PublicRouteRoute
          })
const PublicBookRoute = PublicBookRouteImport.update({
            id: '/book',path: '/book',getParentRoute: () => PublicRouteRoute
          })
const PublicContactRoute = PublicContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => PublicRouteRoute
          })
const PublicDisclaimerRoute = PublicDisclaimerRouteImport.update({
            id: '/disclaimer',path: '/disclaimer',getParentRoute: () => PublicRouteRoute
          })
const PublicEditorialPolicyRoute = PublicEditorialPolicyRouteImport.update({
            id: '/editorial-policy',path: '/editorial-policy',getParentRoute: () => PublicRouteRoute
          })
const PublicHelpRoute = PublicHelpRouteImport.update({
            id: '/help',path: '/help',getParentRoute: () => PublicRouteRoute
          })
const PublicPrivacyRoute = PublicPrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => PublicRouteRoute
          })
const PublicRefundRoute = PublicRefundRouteImport.update({
            id: '/refund',path: '/refund',getParentRoute: () => PublicRouteRoute
          })
const PublicServicesRoute = PublicServicesRouteImport.update({
            id: '/services',path: '/services',getParentRoute: () => PublicRouteRoute
          })
const PublicTermsRoute = PublicTermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => PublicRouteRoute
          })
const BousalaPlayRoute = BousalaPlayRouteImport.update({
            id: '/bousala/play',path: '/bousala/play',getParentRoute: () => rootRouteImport
          })
const DotlovableOauthConsentRoute = DotlovableOauthConsentRouteImport.update({
            id: '/.lovable/oauth/consent',path: '/.lovable/oauth/consent',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminBlogRoute = AuthenticatedAdminBlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminBookingsRoute = AuthenticatedAdminBookingsRouteImport.update({
            id: '/bookings',path: '/bookings',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminBousalaRoute = AuthenticatedAdminBousalaRouteImport.update({
            id: '/bousala',path: '/bousala',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminCasesRoute = AuthenticatedAdminCasesRouteImport.update({
            id: '/cases',path: '/cases',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminFormsRoute = AuthenticatedAdminFormsRouteImport.update({
            id: '/forms',path: '/forms',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminMethodologyKbRoute = AuthenticatedAdminMethodologyKbRouteImport.update({
            id: '/methodology-kb',path: '/methodology-kb',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminPaymentsRoute = AuthenticatedAdminPaymentsRouteImport.update({
            id: '/payments',path: '/payments',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminPendingPurchasesRoute = AuthenticatedAdminPendingPurchasesRouteImport.update({
            id: '/pending-purchases',path: '/pending-purchases',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminServicesRoute = AuthenticatedAdminServicesRouteImport.update({
            id: '/services',path: '/services',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminTestimonialsRoute = AuthenticatedAdminTestimonialsRouteImport.update({
            id: '/testimonials',path: '/testimonials',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminTraumaRoute = AuthenticatedAdminTraumaRouteImport.update({
            id: '/trauma',path: '/trauma',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedBousalaRepairRoute = AuthenticatedBousalaRepairRouteImport.update({
            id: '/bousala/repair',path: '/bousala/repair',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedFormsSlugRoute = AuthenticatedFormsSlugRouteImport.update({
            id: '/forms/$slug',path: '/forms/$slug',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedPortalIndexRoute = AuthenticatedPortalIndexRouteImport.update({
            id: '/portal/',path: '/portal/',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedPortalCoursesRoute = AuthenticatedPortalCoursesRouteImport.update({
            id: '/portal/courses',path: '/portal/courses',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedPortalSmartRoute = AuthenticatedPortalSmartRouteImport.update({
            id: '/portal/smart',path: '/portal/smart',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedPortalTarbawiyaRoute = AuthenticatedPortalTarbawiyaRouteImport.update({
            id: '/portal/tarbawiya',path: '/portal/tarbawiya',getParentRoute: () => AuthenticatedRouteRoute
          })
const PublicBlogIndexRoute = PublicBlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => PublicRouteRoute
          })
const PublicBlogSlugRoute = PublicBlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => PublicRouteRoute
          })
const PublicBookIndexRoute = PublicBookIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PublicBookRoute
          })
const PublicBousalaIndexRoute = PublicBousalaIndexRouteImport.update({
            id: '/bousala/',path: '/bousala/',getParentRoute: () => PublicRouteRoute
          })
const PublicBousalaPendingRoute = PublicBousalaPendingRouteImport.update({
            id: '/bousala/pending',path: '/bousala/pending',getParentRoute: () => PublicRouteRoute
          })
const PublicBousalaSmartRoute = PublicBousalaSmartRouteImport.update({
            id: '/bousala/smart',path: '/bousala/smart',getParentRoute: () => PublicRouteRoute
          })
const PublicBousalaSuccessRoute = PublicBousalaSuccessRouteImport.update({
            id: '/bousala/success',path: '/bousala/success',getParentRoute: () => PublicRouteRoute
          })
const PublicCoursesIndexRoute = PublicCoursesIndexRouteImport.update({
            id: '/courses/',path: '/courses/',getParentRoute: () => PublicRouteRoute
          })
const PublicCoursesSplatRoute = PublicCoursesSplatRouteImport.update({
            id: '/courses/$',path: '/courses/$',getParentRoute: () => PublicRouteRoute
          })
const PublicRTokenRoute = PublicRTokenRouteImport.update({
            id: '/r/$token',path: '/r/$token',getParentRoute: () => PublicRouteRoute
          })
const PublicServicesSlugRoute = PublicServicesSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => PublicServicesRoute
          })
const AuthenticatedAdminBousalaIndexRoute = AuthenticatedAdminBousalaIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAdminBousalaRoute
          })
const AuthenticatedAdminBousalaAnalyticsRoute = AuthenticatedAdminBousalaAnalyticsRouteImport.update({
            id: '/analytics',path: '/analytics',getParentRoute: () => AuthenticatedAdminBousalaRoute
          })
const AuthenticatedAdminBousalaAttemptsRoute = AuthenticatedAdminBousalaAttemptsRouteImport.update({
            id: '/attempts',path: '/attempts',getParentRoute: () => AuthenticatedAdminBousalaRoute
          })
const AuthenticatedAdminBousalaNarrativeCacheRoute = AuthenticatedAdminBousalaNarrativeCacheRouteImport.update({
            id: '/narrative-cache',path: '/narrative-cache',getParentRoute: () => AuthenticatedAdminBousalaRoute
          })
const AuthenticatedAdminBousalaPurchasesRoute = AuthenticatedAdminBousalaPurchasesRouteImport.update({
            id: '/purchases',path: '/purchases',getParentRoute: () => AuthenticatedAdminBousalaRoute
          })
const AuthenticatedAdminBousalaReviewRoute = AuthenticatedAdminBousalaReviewRouteImport.update({
            id: '/review',path: '/review',getParentRoute: () => AuthenticatedAdminBousalaRoute
          })
const AuthenticatedAdminBousalaSettingsRoute = AuthenticatedAdminBousalaSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AuthenticatedAdminBousalaRoute
          })
const AuthenticatedAdminBousalaSmartRoute = AuthenticatedAdminBousalaSmartRouteImport.update({
            id: '/smart',path: '/smart',getParentRoute: () => AuthenticatedAdminBousalaRoute
          })
const AuthenticatedAdminCasesIdRoute = AuthenticatedAdminCasesIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AuthenticatedAdminCasesRoute
          })
const AuthenticatedAdminFormsIdRoute = AuthenticatedAdminFormsIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AuthenticatedAdminFormsRoute
          })
const AuthenticatedPortalBousalaAttemptIdRoute = AuthenticatedPortalBousalaAttemptIdRouteImport.update({
            id: '/portal/bousala/$attemptId',path: '/portal/bousala/$attemptId',getParentRoute: () => AuthenticatedRouteRoute
          })
const PublicBookConfirmIdRoute = PublicBookConfirmIdRouteImport.update({
            id: '/confirm/$id',path: '/confirm/$id',getParentRoute: () => PublicBookRoute
          })
const PublicCoursesTraumaIdRoute = PublicCoursesTraumaIdRouteImport.update({
            id: '/courses/trauma/$id',path: '/courses/trauma/$id',getParentRoute: () => PublicRouteRoute
          })
const PublicShareReportsTokenRoute = PublicShareReportsTokenRouteImport.update({
            id: '/share/reports/$token',path: '/share/reports/$token',getParentRoute: () => PublicRouteRoute
          })
const AuthenticatedAdminBousalaAttemptsIndexRoute = AuthenticatedAdminBousalaAttemptsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAdminBousalaAttemptsRoute
          })
const AuthenticatedAdminBousalaAttemptsAttemptIdRoute = AuthenticatedAdminBousalaAttemptsAttemptIdRouteImport.update({
            id: '/$attemptId',path: '/$attemptId',getParentRoute: () => AuthenticatedAdminBousalaAttemptsRoute
          })
const AuthenticatedAdminBousalaSmartIndexRoute = AuthenticatedAdminBousalaSmartIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAdminBousalaSmartRoute
          })
const AuthenticatedAdminBousalaSmartIdRoute = AuthenticatedAdminBousalaSmartIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AuthenticatedAdminBousalaSmartRoute
          })
const AuthenticatedCoursesTraumaIdLessonsRoute = AuthenticatedCoursesTraumaIdLessonsRouteImport.update({
            id: '/courses/trauma/$id/lessons',path: '/courses/trauma/$id/lessons',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedCoursesTraumaIdPlayRoute = AuthenticatedCoursesTraumaIdPlayRouteImport.update({
            id: '/courses/trauma/$id/play',path: '/courses/trauma/$id/play',getParentRoute: () => AuthenticatedRouteRoute
          })
const PublicCoursesTraumaBuyProductSlugRoute = PublicCoursesTraumaBuyProductSlugRouteImport.update({
            id: '/courses/trauma/buy/$productSlug',path: '/courses/trauma/buy/$productSlug',getParentRoute: () => PublicRouteRoute
          })
const AuthenticatedCoursesTraumaIdResultAttemptIdRoute = AuthenticatedCoursesTraumaIdResultAttemptIdRouteImport.update({
            id: '/courses/trauma/$id/result/$attemptId',path: '/courses/trauma/$id/result/$attemptId',getParentRoute: () => AuthenticatedRouteRoute
          })





const AuthenticatedAdminBousalaAttemptsRouteChildren = {
  AuthenticatedAdminBousalaAttemptsAttemptIdRoute: AuthenticatedAdminBousalaAttemptsAttemptIdRoute,AuthenticatedAdminBousalaAttemptsIndexRoute: AuthenticatedAdminBousalaAttemptsIndexRoute
}

const AuthenticatedAdminBousalaAttemptsRouteWithChildren = AuthenticatedAdminBousalaAttemptsRoute._addFileChildren(AuthenticatedAdminBousalaAttemptsRouteChildren)




const AuthenticatedAdminBousalaSmartRouteChildren = {
  AuthenticatedAdminBousalaSmartIdRoute: AuthenticatedAdminBousalaSmartIdRoute,AuthenticatedAdminBousalaSmartIndexRoute: AuthenticatedAdminBousalaSmartIndexRoute
}

const AuthenticatedAdminBousalaSmartRouteWithChildren = AuthenticatedAdminBousalaSmartRoute._addFileChildren(AuthenticatedAdminBousalaSmartRouteChildren)



const AuthenticatedAdminBousalaRouteChildren = {
  AuthenticatedAdminBousalaAnalyticsRoute: AuthenticatedAdminBousalaAnalyticsRoute,AuthenticatedAdminBousalaAttemptsRoute: AuthenticatedAdminBousalaAttemptsRouteWithChildren,AuthenticatedAdminBousalaNarrativeCacheRoute: AuthenticatedAdminBousalaNarrativeCacheRoute,AuthenticatedAdminBousalaPurchasesRoute: AuthenticatedAdminBousalaPurchasesRoute,AuthenticatedAdminBousalaReviewRoute: AuthenticatedAdminBousalaReviewRoute,AuthenticatedAdminBousalaSettingsRoute: AuthenticatedAdminBousalaSettingsRoute,AuthenticatedAdminBousalaSmartRoute: AuthenticatedAdminBousalaSmartRouteWithChildren,AuthenticatedAdminBousalaIndexRoute: AuthenticatedAdminBousalaIndexRoute
}

const AuthenticatedAdminBousalaRouteWithChildren = AuthenticatedAdminBousalaRoute._addFileChildren(AuthenticatedAdminBousalaRouteChildren)




const AuthenticatedAdminCasesRouteChildren = {
  AuthenticatedAdminCasesIdRoute: AuthenticatedAdminCasesIdRoute
}

const AuthenticatedAdminCasesRouteWithChildren = AuthenticatedAdminCasesRoute._addFileChildren(AuthenticatedAdminCasesRouteChildren)




const AuthenticatedAdminFormsRouteChildren = {
  AuthenticatedAdminFormsIdRoute: AuthenticatedAdminFormsIdRoute
}

const AuthenticatedAdminFormsRouteWithChildren = AuthenticatedAdminFormsRoute._addFileChildren(AuthenticatedAdminFormsRouteChildren)



const AuthenticatedAdminRouteChildren = {
  AuthenticatedAdminBlogRoute: AuthenticatedAdminBlogRoute,AuthenticatedAdminBookingsRoute: AuthenticatedAdminBookingsRoute,AuthenticatedAdminBousalaRoute: AuthenticatedAdminBousalaRouteWithChildren,AuthenticatedAdminCasesRoute: AuthenticatedAdminCasesRouteWithChildren,AuthenticatedAdminFormsRoute: AuthenticatedAdminFormsRouteWithChildren,AuthenticatedAdminMethodologyKbRoute: AuthenticatedAdminMethodologyKbRoute,AuthenticatedAdminPaymentsRoute: AuthenticatedAdminPaymentsRoute,AuthenticatedAdminPendingPurchasesRoute: AuthenticatedAdminPendingPurchasesRoute,AuthenticatedAdminServicesRoute: AuthenticatedAdminServicesRoute,AuthenticatedAdminTestimonialsRoute: AuthenticatedAdminTestimonialsRoute,AuthenticatedAdminTraumaRoute: AuthenticatedAdminTraumaRoute,AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute
}

const AuthenticatedAdminRouteWithChildren = AuthenticatedAdminRoute._addFileChildren(AuthenticatedAdminRouteChildren)



const AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRouteWithChildren,AuthenticatedBousalaRepairRoute: AuthenticatedBousalaRepairRoute,AuthenticatedFormsSlugRoute: AuthenticatedFormsSlugRoute,AuthenticatedPortalCoursesRoute: AuthenticatedPortalCoursesRoute,AuthenticatedPortalSmartRoute: AuthenticatedPortalSmartRoute,AuthenticatedPortalTarbawiyaRoute: AuthenticatedPortalTarbawiyaRoute,AuthenticatedPortalIndexRoute: AuthenticatedPortalIndexRoute,AuthenticatedPortalBousalaAttemptIdRoute: AuthenticatedPortalBousalaAttemptIdRoute,AuthenticatedCoursesTraumaIdLessonsRoute: AuthenticatedCoursesTraumaIdLessonsRoute,AuthenticatedCoursesTraumaIdPlayRoute: AuthenticatedCoursesTraumaIdPlayRoute,AuthenticatedCoursesTraumaIdResultAttemptIdRoute: AuthenticatedCoursesTraumaIdResultAttemptIdRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)




const PublicBookRouteChildren = {
  PublicBookIndexRoute: PublicBookIndexRoute,PublicBookConfirmIdRoute: PublicBookConfirmIdRoute
}

const PublicBookRouteWithChildren = PublicBookRoute._addFileChildren(PublicBookRouteChildren)




const PublicServicesRouteChildren = {
  PublicServicesSlugRoute: PublicServicesSlugRoute
}

const PublicServicesRouteWithChildren = PublicServicesRoute._addFileChildren(PublicServicesRouteChildren)



const PublicRouteRouteChildren = {
  PublicAboutRoute: PublicAboutRoute,PublicBookRoute: PublicBookRouteWithChildren,PublicContactRoute: PublicContactRoute,PublicDisclaimerRoute: PublicDisclaimerRoute,PublicEditorialPolicyRoute: PublicEditorialPolicyRoute,PublicHelpRoute: PublicHelpRoute,PublicPrivacyRoute: PublicPrivacyRoute,PublicRefundRoute: PublicRefundRoute,PublicServicesRoute: PublicServicesRouteWithChildren,PublicTermsRoute: PublicTermsRoute,PublicIndexRoute: PublicIndexRoute,PublicBlogSlugRoute: PublicBlogSlugRoute,PublicBousalaPendingRoute: PublicBousalaPendingRoute,PublicBousalaSmartRoute: PublicBousalaSmartRoute,PublicBousalaSuccessRoute: PublicBousalaSuccessRoute,PublicCoursesSplatRoute: PublicCoursesSplatRoute,PublicRTokenRoute: PublicRTokenRoute,PublicBlogIndexRoute: PublicBlogIndexRoute,PublicBousalaIndexRoute: PublicBousalaIndexRoute,PublicCoursesIndexRoute: PublicCoursesIndexRoute,PublicCoursesTraumaIdRoute: PublicCoursesTraumaIdRoute,PublicShareReportsTokenRoute: PublicShareReportsTokenRoute,PublicCoursesTraumaBuyProductSlugRoute: PublicCoursesTraumaBuyProductSlugRoute
}

const PublicRouteRouteWithChildren = PublicRouteRoute._addFileChildren(PublicRouteRouteChildren)

const rootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,PublicRouteRoute: PublicRouteRouteWithChildren,ActivateRoute: ActivateRoute,AuthRoute: AuthRoute,LinksRoute: LinksRoute,ResetPasswordRoute: ResetPasswordRoute,BousalaPlayRoute: BousalaPlayRoute,DotlovableOauthConsentRoute: DotlovableOauthConsentRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)